import { respondFrom } from 'common/styles/Responsive.styles'
import styled from 'styled-components'

export const StyledContinueButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  p {
    color: #324245;
  }
  ${respondFrom.lessThanTablet`
  margin-top: 20px;
`}

  .calculate-rating {
    margin-left: auto;
    margin-right: 24px;
    display: flex;
    align-items: center;

    > span {
      margin-right: 10px;
      color: #495057;
      font-size: 14px;
    }

    .rating {
      color: #044f98;
      font-weight: 600;

      ::first-letter {
        text-transform: capitalize;
      }
    }
  }
`
